import { Address } from 'wagmi';

enum ContractRoles {
  TradingProtocol,
  WalletFactory,
  WalletProxy,
}

const VOID_ADDRESS = '0x0000000000000000000000000000000000000000';

const networkRolesMapping: any = {
  1: {
    [ContractRoles.TradingProtocol]:
      '0x2176750EAEE750C11b8163265eA7015909437d03',
    [ContractRoles.WalletFactory]: '0xdEA6ea4ee509368EEe917d4e7b5747fBbd4ED8bD',
  },
  137: {
    [ContractRoles.TradingProtocol]:
      '0xE61241e9dD8AA597Aab8a2091D1d8d9117e6024D',
    [ContractRoles.WalletFactory]: '0xe04b1B72350194774584C0843db09AF9a323a3d6',
  },
  5777: {
    [ContractRoles.TradingProtocol]:
      '0x957E0d699d01F312d840da196500CFDbc51B33Dc',
    [ContractRoles.WalletFactory]: '0x1FF5DE4ff273BD63b78CB8D5B69b09aD3BD0940a',
  },
  3: {
    [ContractRoles.TradingProtocol]:
      '0xE9Aad7440333Fd9CA0379Dd5C3142Aec768D5092',
    [ContractRoles.WalletFactory]: '0xd38C3D2c91B8d413ec311f1ee76EdB8F982af918',
  },
  56: {
    [ContractRoles.TradingProtocol]:
      '0x90EE4b10352823a8052C24A03FE6859bcBEbEF34',
    [ContractRoles.WalletFactory]: '0x22628AD51BBd4736323C868951c2e1c15e4a5D51',
  },
  250: {
    [ContractRoles.TradingProtocol]:
      '0xDc0794D004865330292D3Dc8aC1a676D1dAf8618',
    [ContractRoles.WalletFactory]: '0x814C5fC9968D34A1e1A9419dEc35596b2864912d',
  },
  43114: {
    [ContractRoles.TradingProtocol]:
      '0xEbb303A257035A4401724a392fe23B62a8f75c7f',
    [ContractRoles.WalletFactory]: '0xE276d0a73a78d9ceE99fc68C8Ca211410420942b',
  },
  10242: {
    [ContractRoles.TradingProtocol]:
      '0xBb017EB2a798d207960bA6e57E18B70053700e5A',
    [ContractRoles.WalletFactory]: '0x0D0890f4A1A69aCE3709fC63d2e9A63167D32986',
  },
};

const getLimitDeployAddress = (
  networkId: number,
  role: ContractRoles
): Address | undefined => {
  const network = networkRolesMapping[networkId];
  return network ? network[role] : undefined;
};

export { getLimitDeployAddress, ContractRoles, VOID_ADDRESS };
